import React, { FC, useCallback } from 'react'
import { Button, Heading, Icon, Modal, Text, Link } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { Section75DisputeModalSteps, useSection75DisputeModalContext } from '../../Section75DisputeModalContext'
import { useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['dispute']

export interface NotEligibleProps {
  openNormalDisputeModal?: () => void
}

export const NotEligible: FC<NotEligibleProps> = ({ openNormalDisputeModal }) => {
  const { t } = useTranslation(I18N_NAMESPACE)
  const { textSize } = useConsumerSizes()
  const { setStep, closeModal } = useSection75DisputeModalContext()

  const backHandler = useCallback(() => {
    setStep(Section75DisputeModalSteps.ChooseItems)
  }, [setStep])

  const handleContinueNormalDispute = useCallback(() => {
    closeModal()
    if (openNormalDisputeModal != null) {
      openNormalDisputeModal()
    }
  }, [closeModal, openNormalDisputeModal])

  const handleLearnMore = useCallback(() => {
    // TODO: Placeholder url needs to be replaced with actual Section 75 info page
    window.open('https://google.com', '_blank')
  }, [])

  return (
    <>
      <Modal.Header divider={true}>
        <div className='absolute z-10 pt-1'>
          <Button.Link size='Small' onClick={backHandler}>
            <Icon.CaretLeft size='Small' />
          </Button.Link>
        </div>
        <div className='text-center'>
          <Heading size='L'>{t('dispute:section75DisputeModal:notEligible:heading')}</Heading>
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className='flex min-h-[400px] flex-col items-center justify-center space-y-8 text-center'>
          <div>
            <Text bold>{t('dispute:section75DisputeModal:notEligible:message')}</Text>
          </div>
          <Link onClick={handleLearnMore}>
            <Text bold underline size={'S'}>
              {t('dispute:section75DisputeModal:notEligible:learnMore')}
            </Text>
          </Link>
          <Button onClick={handleContinueNormalDispute}>{t('dispute:section75DisputeModal:notEligible:continueNormal')}</Button>
        </div>
      </Modal.Content>
    </>
  )
}
